import {useParams, useNavigate} from 'react-router-dom';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {DetailPageNavigation} from '../navigation/DetailPageNavigation';
import {useReportRun} from '../hooks/useReportRun';
import {Button} from '@mantine/core';

export const DetailPage = () => {

    const {id: componentId} = useParams();
    const navigate = useNavigate();

    if (typeof componentId === 'undefined') {
        throw new Error('componentId is required parameter');
    }

    const {
        record: component,
        loading,
    } = useReportRun(componentId);

    const tools = [
        <Button key='close' variant='default' onClick={() => navigate('/report-runs')}>Close</Button>
    ];

    if (loading || !component) {
        return <PlatformLoader message='Loading report run...Please wait'/>;
    }

    return (
        <FormPageLayout
            title={`Report Run: ${component.id}`}
            pageNavigation={<DetailPageNavigation component={component}/>}
            tools={tools}
        >
            <Profile record={component}/>
        </FormPageLayout>
    );
};
